import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
} from "@mui/material";
import {
  useDeletePositionMutation,
  useGetPositionQuery,
  useGetUserInfoOnyQuery
} from "../../../Api/attoDeskApi";
import { IPosition, IUserAdmin } from "../../../Api/Interface/api.interface";
import NewPopUpDepartment from "../Edit/index";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import CustomCheckbox from "../../../Components/Checkbox.tsx/CustomCheckbox";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import Pagination from "../../../Components/Pagination";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import useIsMobile from "../../../Core/hook/useIsMobile";
import dayjs, { Dayjs } from "dayjs";

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const isMobileRes = useIsMobile();

  const [selectedCoursing, setSelectedCoursing] = useState<IPosition | null>(
    null
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IPosition | null>(
    null
  );

  const { data, isLoading, isError, refetch } = useGetPositionQuery({
    searchText: currentSearchQuery,
  });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleOpenDialog = (coursing: IPosition) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IPosition) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeletePositionMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the position");
    }
  };

  if (isLoading || userIsLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  const coursings: IPosition[] = Array.isArray(data?.data)
    ? (data?.data as IPosition[])
    : [];

  const handleAddProductClick = () => {
    navigate("/position/create");
  };

  return (
    <Card className={classes.card}>
      {isMobileRes ? (
        <Grid
          container
          justifyContent={"space-between"}
          spacing={2}
          sx={{ padding: 2 }}
          className={classes.titleGrid}
        >
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="flex-end"
              sx={{ display: "flex" }}
            >
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CiSearch className={classes.searchWidgetIcon} />
                      </InputAdornment>
                    ),
                    classes: {
                      root: classes.formControlList,
                    },
                  }}
                  fullWidth
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Position  .."
                  className={classes.searchTextField}
                  size="small"
                />
              </Grid>
              <Grid item>
                <Button
                  // variant="contained"
                  className={classes.addNewButton}
                  onClick={handleAddProductClick}
                >
                  Add New
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          justifyContent={"space-between"}
          spacing={5}
          sx={{ padding: 2 }}
          className={classes.titleGrid}
        >
          
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="flex-end"
              sx={{ display: "flex" }}
            >
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CiSearch className={classes.searchWidgetIcon} />
                      </InputAdornment>
                    ),
                    classes: {
                      root: classes.formControlList,
                    },
                  }}
                  fullWidth
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Position  .."
                  className={classes.searchTextField}
                  size="small"
                />
              </Grid>
              <Grid item>
              <Link to={`/position/create`} className={classes.iconLinkPropNormal}>

                <Button
                  // variant="contained"
                  className={classes.addNewButton}
                  onClick={handleAddProductClick}
                >
                  Add New
                </Button>
              </Link>

              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}

      <Grid>
        <TableContainer>
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}>
                  <strong>Position</strong>
                </TableCell>
                {!isMobileRes && (
                  <TableCell
                    className={classes.tablheader}
                    // sx={{ textAlign: "center" }}
                  >
                    <strong>Description</strong>
                  </TableCell>
                )}
                 {!isMobileRes && (
                  <TableCell
                    className={classes.tablheader}
                    // sx={{ textAlign: "center" }}
                  >
                    <strong>Create By</strong>
                  </TableCell>
                )}
                <TableCell
                  className={classes.tablheader}
                  sx={{ textAlign: "right" }}
                >
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      height="10vh"
                    >
                      <CircularProgress />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : isError || coursings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                coursings
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: IPosition, index) => (
                    <TableRow key={row.id} className={classes.tableRowHover}>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {toProperCase(row.positionName)}
                      </TableCell>
                      {!isMobileRes && (
                        <TableCell
                          scope="row"
                          className={classes.tablCell}
                          // sx={{ textAlign: "center" }}
                        >
                          {row.positionDescription}
                        </TableCell>
                      )}
                      {!isMobileRes && (
                        <TableCell
                          scope="row"
                          className={classes.tablCell}
                          // sx={{ textAlign: "center" }}
                        >
                          <Typography>
                            {userMap.get(row.created_by) || ""}
                          </Typography>
                          <Typography>
                            {dayjs(row.created_at).format(
                              "MMM D, YYYY hh:mm A"
                            )}
                          </Typography>
                        </TableCell>
                      )}
                      <TableCell className={classes.tablCell}>
                        <Grid
                          container
                          spacing={1}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Grid item>
                            <Button
                              // variant="contained"
                              className={classes.editButtonList}
                              onClick={() => handleOpenDialog(row)}
                            >
                              <EditSharpIcon className={classes.editListIcon} />
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              // variant="contained"
                              className={classes.deleteButtonList}
                              onClick={() => handleOpenDeletePopup(row)}
                            >
                              <DeleteOutlineSharpIcon
                                className={classes.deleteListIcon}
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
          <Grid
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={coursings.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </TableContainer>
        {selectedCoursing && (
          <NewPopUpDepartment
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedCoursing}
          />
        )}
        {coursingToDelete && (
          <DeletePopup
            open={openDeleteCategory}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(coursingToDelete.id.toString());
            }}
            title="Delete Position"
            content={`Are you sure you want to delete "${coursingToDelete.positionName}"?`}
          />
        )}
      </Grid>
    </Card>
  );
};

export default Index;
